import { render, staticRenderFns } from "./StolpskyddSignal.vue?vue&type=template&id=12cea173"
import script from "./StolpskyddSignal.vue?vue&type=script&lang=js"
export * from "./StolpskyddSignal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports